<template>
  <input type="range" :min="min" :max="max" :step="step" :value="value" @input="onRangeStyle" ref="inputRange" :style="{ backgroundSize: styleWidth + '% 100%'}">
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1000
    },
    step: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      range: this.value
    };
  },
  methods: {
    onRangeStyle (e) {
      this.$emit('input', e.target.value);
    }
  },
  computed: {
    styleWidth () {
      let style1 = (this.value - this.min) * 100;
      let style2 = (this.max - this.min);
      let styleMath = style1 / style2;
      if (style1 !== 0 && style2 !== 0) {
        return styleMath;
      } else {
        styleMath = 0;
        return styleMath;
      }
    }
  },
  watch: {
    range: function () {
      this.$emit('input', this.range);
    },
    value: {
      handler: function (val) {
        this.value = val;
        // let runStyle = (this.value - this.min) * 100 / (this.max - this.min)
        // this.styleWidth = runStyle
      },
      immediate: true
    }
  }
};
</script>
